import type { PermissionList } from 'types/permissions';
import type { SchemaProperty } from 'types/schema';

/**
 * The names of the properties the viewer cannot write (ADR-022 write gate). These render disabled
 * with a lock, and section contexts derive their `mode`/`editable` from this set.
 *
 * - A property with `access.write` is blocked unless `permissionList` grants that action. A missing
 *   list blocks every such property (fail closed).
 * - A `read_only` property is always blocked: the engine or a dedicated endpoint owns its value, and
 *   `PATCH /spheres/:id/properties` rejects any attempt to set one.
 */
export function computeWriteBlockedProps(
  properties: readonly SchemaProperty[],
  permissionList: PermissionList | null | undefined
): Set<string> {
  const blocked = new Set<string>();
  for (const prop of properties) {
    const writeAction = prop.access?.write;
    if (prop.read_only || (writeAction && !(permissionList?.permissions?.[writeAction] ?? false))) {
      blocked.add(prop.name);
    }
  }
  return blocked;
}
